/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: LogProfilesColumns.tsx
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Custom column renderers for Log Profiles DataGrid.
────────────────────────────────────────────────────────────────*/

import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';
import { LogProfile } from '../types';

export function useLogProfilesColumnRenderers() {
  const { t, i18n } = useI18n();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString(
      i18n.language === 'es' ? 'es-ES' : 'en-US',
      {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      },
    );
  };

  const columnRenderers = useMemo(
    () => ({
      description: (value: string | undefined) => (
        <div className="text-muted-foreground">{value || '—'}</div>
      ),
      created_at: (value: string) => (
        <div className="text-foreground">{formatDate(value)}</div>
      ),
      updated_at: (value: string) => (
        <div className="text-foreground">{formatDate(value)}</div>
      ),
    }),
    [i18n.language],
  );

  return columnRenderers;
}

